import React from "react"
import Relay from "react-relay"
import Helmet from "react-helmet"
import { Link, withRouter } from "react-router"
import { dispatch } from "../../Dispatcher"
import {
  getPDFSrcFromResource,
  getPDFSrcFromFile
} from "../../scripts/resource"
import { isomorphicVars } from "../../scripts/isomorphicVars"
import Icon from "../elements/Icon"
import { getStyles } from "../../styles/dynamicStyles"

class PDFiframe extends React.Component {
  componentWillMount() {
    this._propsDispatch()
  }

  componentWillUnmount() {
    dispatch({ type: "view-disable-header-pad", value: false })
    dispatch({ type: "view-disable-footer", value: false })
  }

  _propsDispatch = () => {
    /**
     * OK OK OK  HACK
     *  This ( Dispatching based on props ) should never be done.
     * But we have to because Toivo loves having all the classes in the body tag
     * The only way the body tag can know about whats going on in this component is to send a message up
     * And what we send up depends on our props.
     *
     * Kind of a problem unique to Relay, as this component fetches props that a parent component has
     * no knowledge of.
     *
     * To make this work at all I have to put it in a setTimeout, so that it is fired on the next tick
     * otherwise react will recognise this as a dispatch during a dispatch and block it.
     */

    setTimeout(() => {
      dispatch({ type: "view-disable-header-pad", value: true })
      dispatch({ type: "view-disable-footer", value: true })
    }, 1)
  }

  render() {
    const resource = this.props.resource
    const files = resource && resource.files
    const file =
      this.props.file && files && files.find(f => f.id === this.props.file)

    const pdfSource = file
      ? getPDFSrcFromFile(file)
      : getPDFSrcFromResource(resource)
    const { public_url: publicURL } = isomorphicVars()

    return (
      <main
        className="c-pdf-view"
        id="main"
        role="main"
        tabIndex={0}
        data-article-style="page"
      >
        <div className="c-pdf-view__inner">
          <Helmet title={resource.title} />
          <iframe
            className="c-pdf-view__iframe"
            src={`/pdfjs/web/viewer.html?file=${encodeURIComponent(
              pdfSource
            )}&originsiteurl=${encodeURIComponent(publicURL)}`}
            frameBorder="0"
          />
          <div
            className="c-mviewer__tools"
            style={getStyles("c-mviewer__tools")}
          >
            <Link
              className="button"
              to={`/item/${resource.id}${file ? `?file=${file.id}` : ""}`}
              title="Exit Fullscreen"
            >
              <Icon icon="contract" />
            </Link>
          </div>
          <div className="js-trigger-chrome">
            {/*needed to tell the header component to go into reduced mode... bit silly linking to a html component, but then well, so it goes*/}
          </div>
        </div>
      </main>
    )
  }
}

export default Relay.createContainer(withRouter(PDFiframe), {
  fragments: {
    resource: () => Relay.QL`
      fragment on Resource {
        id
        title
        type
        files {
          id
          type
          documents {
            pdf { url }
          }
        }
      }
    `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/pages/PDFiframe.js